import React from 'react';
import AuthLayout from '../../components/AuthLayout';
import RegistrationForm from './components/RegistrationForm';
import LoginRedirect from './components/LoginRedirect';

const Register = () => {
  return (
    <AuthLayout
      title="Создать аккаунт"
      subtitle="Начните создавать лендинги для вашего бизнеса за несколько минут"
    >
      <RegistrationForm />
      <LoginRedirect />
    </AuthLayout>
  );
};

export default Register;